import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Cms::MwContentPage @content={{this.model.content}} />",{ moduleName: "mewe/templates/move-to-web3.hbs" })